<template>
  <div id="dataPreview" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <el-button class="ml-0px mr-5px float-right" size="small" @click="goBack">{{
          $t('返回')
        }}</el-button>
      </el-row>
      <div class="tableList mt-10px mb-10px">
        <el-table
          :data="sourceDataList"
          v-loading="listLoading"
          border
          height="calc(100% - 42px)"
          ref="multipleTable"
          stripe
          row-key="id"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            align="center"
            v-for="(tItem, tIndex) in tableHeader"
            show-overflow-tooltip
            :key="tIndex"
            :label="tItem.name"
          >
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                v-if="scope.row.dataValueDtos[tIndex].errValueList.length !== 0"
                popper-class="wrap"
                trigger="hover"
              >
                <div class="triangle"></div>
                <ul>
                  <li
                    v-for="(item, index) in scope.row.dataValueDtos[tIndex].errValueList"
                    :key="index"
                    class="tc"
                  >
                    {{ item }}
                  </li>
                </ul>
                <div slot="reference">
                  <div
                    :class="{
                      'error-tips': true,
                      'border-red':
                        scope.row.dataValueDtos[tIndex].errValueList.length !== 0 &&
                        !scope.row.dataValueDtos[tIndex].afterValue,
                    }"
                    class="ell"
                  >
                    <el-input
                      size="samll"
                      ref="tableInput"
                      v-if="scope.row.dataValueDtos[tIndex].errValueList.length !== 0"
                      v-model="scope.row.dataValueDtos[tIndex].beforeValue"
                      readonly
                    ></el-input>
                    <!-- 这儿使用template包裹是为了尽可能的不改变element-ui已封装好的样式能够作用到重新渲染的节点上 -->
                    <template v-else-if="scope.row.dataValueDtos[tIndex].afterValue === ''">
                      {{ scope.row.dataValueDtos[tIndex].beforeValue }}
                    </template>
                    <template v-else>
                      {{ scope.row.dataValueDtos[tIndex].afterValue }}
                    </template>
                  </div>
                </div>
              </el-popover>
              <!-- 这儿使用template包裹是为了尽可能的不改变element-ui已封装好的样式能够作用到重新渲染的节点上 -->
              <template v-else>
                {{ scope.row.dataValueDtos[tIndex].beforeValue }}
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="documentListDataSize"
          @current-change="getErrorDetailLits"
          :current-page.sync="sourceTableParam.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size.sync="sourceTableParam.pageSize"
          layout="->, total, sizes, prev, pager, next"
          :total="totalNumberL"
          class="r mt-10px"
        ></el-pagination>
      </div>
      <div class="approvalTips">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="$t('请填写审批意见')"
          v-model="message"
          :disabled="disabledBtn || type === 'preview'"
        >
        </el-input>
        <el-row class="text-center mt-10px">
          <el-button
            size="small"
            type="primary"
            @click="submitData(true)"
            :disabled="disabledBtn || type === 'preview'"
            >{{ $t('审批通过') }}</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitData(false)"
            :disabled="disabledBtn || type === 'preview'"
            >{{ $t('审批驳回') }}</el-button
          >
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import StandardManagementService from '@/services/thApi/StdClassDataBatch'
import dataService from '@/services/DataReceptionService'

export default {
  data() {
    return {
      sourceDataList: [],
      tableHeader: [],
      listLoading: false,
      totalNumberL: 0,
      classId: '',
      taskId: '',
      id: '',
      sourceTableParam: {
        pageNo: 1,
        pageSize: 15,
      },
      message: '',
      disabledBtn: false,
      type: '',
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    documentListDataSize() {
      this.sourceTableParam.pageNo = 1
      this.getErrorDetailLits()
    },
    // 获取错误详情
    async getErrorDetailLits() {
      this.sourceDataList = []
      if (!this.classId) return
      this.listLoading = true
      const res = await StandardManagementService.getDataError({
        pageIndex: this.sourceTableParam.pageNo,
        pageSize: this.sourceTableParam.pageSize,
        stdClassId: this.classId,
      })
      this.listLoading = false
      if (res && res.data && res.code === 0) {
        this.tableHeader = res.data.headerInfos
        this.totalNumberL = res.data.totalCount
        const tableData = res.data.data
        _.forEach(tableData, (sourceItem, sourceIndex) => {
          const sourceOne = {
            dataValueDtos: [], // table渲染的数据
            isEditColumn: [], // 可编辑列
          }
          Object.keys(sourceItem).forEach((key) => {
            const rowIndex = _.findIndex(this.tableHeader, ['columnName', key])
            if (rowIndex === -1) return
            const label = _.find(this.tableHeader, { columnName: key }).name
            const someOne = {
              beforeValue: sourceItem[key].value,
              afterValue: '',
              errValueList: sourceItem[key].exceptions ? sourceItem[key].exceptions : [],
            }
            if (sourceItem[key].exceptions && sourceItem[key].exceptions.length > 0) {
              someOne.label = label
              someOne.position = `${sourceIndex},${rowIndex}`
              sourceOne.isEditColumn.push(label)
            }
            // header和data的顺序保持一致
            sourceOne.dataValueDtos[rowIndex] = someOne
            // sourceOne.id = sourceItem.id.value
          })
          this.sourceDataList.push(sourceOne)
        })
      }
    },
    // 审批操作
    async submitData(val) {
      const res = await dataService.approval({
        id: this.id,
        approveOpinion: this.message,
        isPass: val, // true为审批通过,false为审批驳回
        taskRunId: this.taskId,
      })
      if (res && res.code === 0) {
        this.$message.success(res.msg)
        this.goBack()
        this.disabledBtn = true
      }
    },
  },
  created() {
    this.disabledBtn = false
    this.classId = this.$route.query.classId
    this.taskId = this.$route.query.taskRunId
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.getErrorDetailLits()
  },
}
</script>

<style lang="scss" scoped>

.tableList {
  height: 50%;
}
.tips {
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 99;
  .triangle {
    border-top: 10px solid transparent;
    border-bottom: 10px solid #ff1818;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    width: 20px;
    height: 20px;
    margin-left: 40%;
  }
  ul {
    background: #ff1818;
    color: #fff;
    padding: 0 20px;
  }
}
.approvalTips {
  padding: 0 300px;
  height: calc(50% - 42px);
}
.border-red {
  border: 1px solid red;
  color: red;
}
.error-tips {
  width: 100%;
  height: 100%;
  /deep/ .el-input {
    height: 100%;

    .el-input__inner {
      height: 100%;
      border: none !important;
    }
  }
}

</style>
